import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';

import {API_TASK_STEP_SUBMIT} from '../../../../config/urls';
import {UrlService} from '@shared/services/url.service';
import {TaskStepUpdateDto} from '@dto/tasks/task-step-update.dto';

@Injectable({
  providedIn: 'root'
})
export class AdaptiveCardTaskService {
  private readonly http = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  public save(taskId: string, taskStepId: number, adaptiveCardData: Record<string, string>): Observable<TaskStepUpdateDto> {
    const endpointUrl = this.urlService.buildUrl(API_TASK_STEP_SUBMIT, taskId, String(taskStepId));
    return this.http.post<TaskStepUpdateDto>(endpointUrl, adaptiveCardData);
  }
}
